module.exports = __webpack_public_path__ + "static/media/06.895ece75.mp3";